<template>
  <div class="app-container">
    <!-- 题库提示信息 -->
    <div v-if="$route.query.repoId && $route.query.repoTitle" class="repo-info-banner" style="margin-bottom: 20px; padding: 15px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border-radius: 8px; box-shadow: 0 2px 12px rgba(0,0,0,0.1);">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex; align-items: center;">
          <i class="el-icon-folder-opened" style="font-size: 20px; margin-right: 10px;"></i>
          <span style="font-size: 16px; font-weight: bold;">当前查看题库：{{ $route.query.repoTitle }}</span>
        </div>
        <el-button type="text" style="color: white; font-size: 14px;" @click="clearRepoFilter">
          <i class="el-icon-close"></i> 清除筛选
        </el-button>
      </div>
    </div>

    <!-- form -->

    <el-form :inline="true" :model="formInline" class="demo-form-inline"
      style="display: flex; align-items: center; flex-wrap: wrap;">
      <el-form-item label="试题名称">
        <el-input v-model="searchName" placeholder="输入试题名称" />
      </el-form-item>
      <el-form-item label="所属题库">
        <repo-select v-model="selectedRepoSingleSearch" @change="handleRepoChangeSingle" />
      </el-form-item>
      <el-form-item label="题库类型">
        <el-select v-model="selValue" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item style="margin-right: 10px">
        <el-button type="primary" @click="searchQu">查询</el-button>
      </el-form-item>
      <el-form-item style="margin-right: 10px">
        <el-button type="primary" @click="screenInfo()">新增</el-button>
      </el-form-item>
      <el-form-item style="margin-right: 10px">
        <el-button type="primary" @click="fileDialogVisible = true">导入</el-button>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="test">markdown导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="ocrImportDialogVisible = true">OCR导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handlePdfImportClick">PDF导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" :disabled="selectedQuestions.length === 0" @click="batchDeleteQuestions">批量删除</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="showClearKnowledgeDialog">清除知识点</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="showImportKnowledgeDialog">导入知识点</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showUpdateKnowledgeDialog">更新知识点(Markdown)</el-button>
      </el-form-item>
    </el-form>

    <!-- OCR导入 -->
    <el-dialog width="600px" :show-close="false" :close-on-click-modal="false" title="OCR识别题目"
      :visible.sync="ocrImportDialogVisible">
      <div style="margin-bottom: 15px;">
        <label style="display: block; margin-bottom: 8px; font-weight: bold;">请选择题库：</label>
        <repo-select v-model="selectedRepoSingleOcrImport" style="width: 100%"
          @change="handleRepoChangeSingle" :disabled="!!$route.query.repoId" />
        <div v-if="$route.query.repoId" style="margin-top: 8px; color: #409eff; font-size: 14px;">
          <i class="el-icon-info"></i> 当前已自动选择题库：{{ $route.query.repoTitle }}
        </div>
      </div>

      <!-- 上传题目图片 -->
      <div style="margin-bottom: 20px;">
        <label style="display: block; margin-bottom: 8px; font-weight: bold;">上传题目：</label>
        <el-upload class="upload-demo" drag action="" multiple :limit="10" accept=".jpg,.jpeg,.png"
          :auto-upload="false" :on-remove="handleRemove" :on-change="handleFileChange" :file-list="fileList">
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">支持多张图片，建议jpg/png</div>
        </el-upload>
      </div>

      <!-- 上传答案图片 -->
      <div style="margin-bottom: 20px;">
        <label style="display: block; margin-bottom: 8px; font-weight: bold;">上传答案：</label>
        <el-upload class="upload-demo" drag action="" multiple :limit="10" accept=".jpg,.jpeg,.png"
          :auto-upload="false" :on-remove="handleAnswersFileRemove" :on-change="handleAnswersFileChange" :file-list="answersFileList">
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">支持多张图片，建议jpg/png</div>
        </el-upload>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="ocrImportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="useOcr">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 文件上传 -->
    <el-dialog width="400px" :show-close="false" :close-on-click-modal="false" title="上传文件"
      :visible.sync="fileDialogVisible">
      <!-- v-model="scope.row.repoId" -->
      <!-- @change="repoChange($event, scope.row)" -->
      请选择科目：
      <repo-select v-model="selectedRepoSingle" style="margin-bottom: 10px" @change="handleRepoChangeSingle" :disabled="!!$route.query.repoId" />
      <div v-if="$route.query.repoId" style="margin-bottom: 10px; color: #409eff; font-size: 14px;">
        <i class="el-icon-info"></i> 当前已自动选择题库：{{ $route.query.repoTitle }}
      </div>
      <el-upload class="upload-demo" drag action="xxxxxx" multiple :limit="1" accept=".xlsx, .xls" :auto-upload="false"
        :on-remove="handleRemove" :on-change="handleFileChange" :file-list="fileList">
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fileDialogVisible = false">取 消</el-button>
        <el-button type="success" plain @click="startDownload">下载模板</el-button>
        <el-button type="primary" @click="importQu">确 定</el-button>
      </div>
    </el-dialog>

    <!-- OCR识别结果 -->
    <el-dialog title="OCR识别结果" :visible.sync="ocrResultDialogVisible" width="80%">
      <!-- 统计信息 -->
      <div style="margin-bottom: 20px; padding: 15px; background-color: #f5f7fa; border-radius: 4px;">
        <el-row :gutter="20">
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #409eff;">{{ ocrResults.length }}</div>
              <div style="color: #666;">总题目数</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #67c23a;">{{ getQuestionTypeCount('choice') }}</div>
              <div style="color: #666;">选择题</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #e6a23c;">{{ getQuestionTypeCount('fill') }}</div>
              <div style="color: #666;">填空题</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #f56c6c;">{{ getQuestionTypeCount('application') }}</div>
              <div style="color: #666;">简答题</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-table :data="ocrResults" border style="width: 100%">
        <el-table-column prop="index" label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="题目内容">
          <template slot-scope="scope">
            <el-input v-model="scope.row.content" type="textarea" :rows="2" />
          </template>
        </el-table-column>
        <el-table-column prop="answer" label="答案">
          <template slot-scope="scope">
            <el-input v-model="scope.row.answer" type="textarea" :rows="2" />
            <div v-if="scope.row.type === 'choice' && scope.row.options && scope.row.options.length > 0" style="margin-top: 5px; font-size: 12px; color: #666;">
              提示：答案应为选项字母，如 A、B、C、D
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="options" label="选项" width="250">
          <template slot-scope="scope">
            <div class="options-container">
              <div v-if="scope.row.options && scope.row.options.length > 0">
                <div v-for="(option, index) in scope.row.options" :key="index" class="option-item">
                  <span class="option-label">{{ String.fromCharCode(65 + index) }}.</span>
                  <el-input v-model="scope.row.options[index]" size="small" class="option-input" />
                  <el-button type="text" size="mini" @click="removeOption(scope.$index, index)" class="option-delete-btn" style="color: #f56c6c;">删除</el-button>
                </div>
              </div>
              <div v-else>
                <span style="color: #999; font-style: italic;">暂无选项</span>
              </div>
            </div>
            <el-button type="text" size="mini" @click="addOption(scope.$index)" style="margin-top: 8px; color: #409eff;">
              <i class="el-icon-plus"></i> 添加选项
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="knowledge" label="知识点">
          <template slot-scope="scope">
            <el-input v-model="scope.row.knowledge" type="textarea" :rows="2" />
          </template>
        </el-table-column>
        <el-table-column prop="analysis" label="解析">
          <template slot-scope="scope">
            <el-input v-model="scope.row.analysis" type="textarea" :rows="2" />
          </template>
        </el-table-column>
        <el-table-column prop="type" label="题目类型" width="120">
          <template slot-scope="scope">
            <el-select v-model="scope.row.type">
              <el-option v-for="item in quTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="sourceImage" label="来源图片" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.sourceImage" size="small" type="info">
              {{ scope.row.sourceImage }}
            </el-tag>
            <span v-else style="color: #999;">未知来源</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.prevent="previewQuestion(scope.row)" style="color: #409eff;">预览</el-button>
            <el-button type="text" size="small" @click.prevent="deleteRow(scope.$index)" style="color: #f56c6c;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ocrResultDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOcrResults">保 存</el-button>
      </div>
    </el-dialog>

    <!-- Markdown导入 -->
    <el-dialog title="Markdown导入" :visible.sync="wordDialogVisible" width="400px">
      请选择题库：
      <repo-select v-model="selectedRepoSingleMdImport" style="margin-bottom: 10px; width: 100%" @change="handleRepoChangeSingle" :disabled="!!$route.query.repoId" />
      <div v-if="$route.query.repoId" style="margin-bottom: 10px; color: #409eff; font-size: 14px;">
        <i class="el-icon-info"></i> 当前已自动选择题库：{{ $route.query.repoTitle }}
      </div>
      <el-upload
        class="upload-demo"
        drag
        action=""
        :auto-upload="false"
        :file-list="wordFileList"
        :on-change="handleWordFileChange"
        :on-remove="handleWordFileRemove"
        accept=".md,.markdown"
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将Markdown文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">支持 .md / .markdown 文件</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitMarkdownFile">提交</el-button>
      </span>
    </el-dialog>

    <!-- PDF导入 -->
    <el-dialog title="PDF导入" :visible.sync="pdfImportDialogVisible" width="400px">
      请选择科目：
      <repo-select v-model="selectedRepoSinglePdfImport" style="margin-bottom: 10px; width: 100%" @change="handleRepoChangeSingle" :disabled="!!$route.query.repoId" />
      <div v-if="$route.query.repoId" style="margin-bottom: 10px; color: #409eff; font-size: 14px;">
        <i class="el-icon-info"></i> 当前已自动选择题库：{{ $route.query.repoTitle }}
      </div>
      <el-upload
        class="upload-demo"
        drag
        action=""
        :auto-upload="false"
        :file-list="pdfFileList"
        :on-change="handlePdfFileChange"
        :on-remove="handlePdfFileRemove"
        accept=".pdf"
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将PDF文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传PDF文件</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pdfImportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPdfFile">提交</el-button>
      </span>
    </el-dialog>

    <!-- Markdown导入结果 -->
    <el-dialog title="Markdown导入结果" :visible.sync="mdResultDialogVisible" width="80%">
      <!-- 统计信息 -->
      <div style="margin-bottom: 20px; padding: 15px; background-color: #f5f7fa; border-radius: 4px;">
        <el-row :gutter="20">
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #409eff;">{{ mdResults.length }}</div>
              <div style="color: #666;">总题目数</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #67c23a;">{{ getMdChoiceCount() }}</div>
              <div style="color: #666;">选择题</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #e6a23c;">{{ getMdEssayCount() }}</div>
              <div style="color: #666;">简答题</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #606266;">{{ mdResults.filter(q => q.selected).length }}</div>
              <div style="color: #666;">已选择</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 批量操作 -->
      <div style="margin-bottom: 15px;">
        <el-button size="small" @click="selectAllMdQuestions">全选</el-button>
        <el-button size="small" @click="deselectAllMdQuestions">取消全选</el-button>
        <el-button size="small" type="danger" @click="deleteSelectedMdQuestions">删除选中</el-button>
      </div>

      <!-- 题目列表 -->
      <el-table :data="mdResults" border style="width: 100%" max-height="500">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-width="120px" size="mini" style="padding: 10px 20px;">
              <el-form-item label="question_id">
                <el-input v-model="props.row.questionId" placeholder="question_id"></el-input>
              </el-form-item>
              <el-form-item label="英文题干">
                <el-input v-model="props.row.englishQuestion" type="textarea" :rows="2" placeholder="original_english_question"></el-input>
              </el-form-item>
              <el-form-item label="中文题干">
                <el-input v-model="props.row.chineseQuestion" type="textarea" :rows="2" placeholder="chinese_translation"></el-input>
              </el-form-item>
              <el-form-item label="题目类型">
                <el-input v-model="props.row.questionType" placeholder="question_type"></el-input>
              </el-form-item>
              <el-form-item label="标签">
                <el-input v-model="props.row.tags" placeholder="question_tags"></el-input>
              </el-form-item>
              <el-form-item label="难度等级">
                <el-input v-model="props.row.difficultyLevelText" placeholder="difficulty_level"></el-input>
              </el-form-item>
              <el-form-item label="正确答案">
                <el-input v-model="props.row.correctAnswer" placeholder="correct_answer"></el-input>
              </el-form-item>
              <el-form-item label="英文解析">
                <el-input v-model="props.row.englishExplanation" type="textarea" :rows="3" placeholder="english_explanation"></el-input>
              </el-form-item>
              <el-form-item label="中文解析">
                <el-input v-model="props.row.chineseExplanation" type="textarea" :rows="3" placeholder="chinese_explanation"></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="55" align="center">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.selected"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="序号" width="70" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="题目ID" width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.questionId" placeholder="question_id"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="中文题干" min-width="260">
          <template slot-scope="scope">
            <el-input v-model="scope.row.chineseQuestion" type="textarea" :rows="2" placeholder="中文题干"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="选项" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.options && scope.row.options.length > 0">
              <div v-for="(opt, idx) in scope.row.options" :key="idx" style="font-size: 12px;">
                {{ String.fromCharCode(65 + idx) }}. {{ opt }}
              </div>
            </div>
            <span v-else style="color: #999;">无选项</span>
          </template>
        </el-table-column>
        <el-table-column label="答案" width="90">
          <template slot-scope="scope">
            <el-input v-model="scope.row.correctAnswer" placeholder="答案"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="中文解析" width="220">
          <template slot-scope="scope">
            <el-input v-model="scope.row.chineseExplanation" type="textarea" :rows="2" placeholder="中文解析"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="标签" width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.tags" placeholder="标签"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="难度" width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.difficultyLevelText" placeholder="Level A"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="deleteMdQuestion(scope.$index)" style="color: #f56c6c;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mdResultDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveMdResults" :disabled="mdResults.filter(q => q.selected).length === 0">保存选中题目</el-button>
      </div>
    </el-dialog>

    <!-- PDF识别结果 -->
    <el-dialog title="PDF识别结果" :visible.sync="pdfResultDialogVisible" width="80%">
      <!-- 统计信息 -->
      <div style="margin-bottom: 20px; padding: 15px; background-color: #f5f7fa; border-radius: 4px;">
        <el-row :gutter="20">
          <el-col :span="4">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #409eff;">{{ pdfResults.length }}</div>
              <div style="color: #666;">总题目数</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #67c23a;">{{ getPdfValidCount() }}</div>
              <div style="color: #666;">有效题目</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #e6a23c;">{{ getPdfChoiceCount() }}</div>
              <div style="color: #666;">选择题</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #f56c6c;">{{ getPdfEssayCount() }}</div>
              <div style="color: #666;">简答题</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #909399;">{{ getPdfInvalidCount() }}</div>
              <div style="color: #666;">无效题目</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #606266;">{{ pdfResults.filter(q => q.selected).length }}</div>
              <div style="color: #666;">已选择</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 批量操作 -->
      <div style="margin-bottom: 15px;">
        <el-button size="small" @click="selectAllValidPdfQuestions">选择所有有效题目</el-button>
        <el-button size="small" @click="deselectAllPdfQuestions">取消全选</el-button>
        <el-button size="small" type="danger" @click="deleteSelectedPdfQuestions">删除选中</el-button>
        <el-button size="small" type="success" @click="showAddQuestionForm">手动添加题目</el-button>
        <el-button size="small" type="primary" :disabled="pdfResults.filter(q => q.selected && q.isValid).length === 0" @click="noopKnowledgeFetch">获取知识点</el-button>
      </div>

      <!-- 手动添加题目表单 -->
      <el-card v-if="showManualAddForm" style="margin-bottom: 20px;" shadow="hover">
        <div slot="header" class="clearfix">
          <span>手动添加题目</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="cancelAddQuestion">取消</el-button>
        </div>
        <el-form :model="newQuestion" label-width="80px">
          <el-form-item label="题目类型">
            <el-radio-group v-model="newQuestion.type">
              <el-radio :label="1">选择题</el-radio>
              <el-radio :label="4">简答题</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="题目内容">
            <el-input v-model="newQuestion.stem" type="textarea" :rows="3" placeholder="请输入题目内容"></el-input>
          </el-form-item>
          <el-form-item v-if="newQuestion.type === 1" label="选项">
            <div v-for="(option, index) in newQuestion.options" :key="index" style="margin-bottom: 10px;">
              <el-row :gutter="10">
                <el-col :span="2">
                  <span style="font-weight: bold;">{{ String.fromCharCode(65 + index) }}.</span>
                </el-col>
                <el-col :span="20">
                  <el-input v-model="newQuestion.options[index]" :placeholder="'选项' + String.fromCharCode(65 + index)"></el-input>
                </el-col>
                <el-col :span="2">
                  <el-button v-if="newQuestion.options.length > 2" type="text" size="small" @click="removeManualOption(index)" style="color: #f56c6c;">删除</el-button>
                </el-col>
              </el-row>
            </div>
            <el-button v-if="newQuestion.options.length < 6" type="text" size="small" @click="addManualOption">+ 添加选项</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addManualQuestion">添加题目</el-button>
            <el-button @click="cancelAddQuestion">取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <el-table :data="pdfResults" border style="width: 100%" max-height="500">
        <el-table-column type="selection" width="55" :selectable="row => row.isValid">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.selected" :disabled="!scope.row.isValid"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="question_id" label="题号" width="80" align="center" />
        <el-table-column prop="stem" label="题目内容" min-width="300">
          <template slot-scope="scope">
            <el-input v-if="scope.row.isValid" v-model="scope.row.stem" type="textarea" :rows="3" />
            <span v-else style="color: #999; font-style: italic;">{{ scope.row.stem || '无效题目' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="options" label="选项" width="250">
          <template slot-scope="scope">
            <div v-if="scope.row.isValid && scope.row.options && scope.row.options.length > 0">
              <div v-for="(option, index) in scope.row.options" :key="index" style="margin-bottom: 5px;">
                <el-input v-model="scope.row.options[index]" size="small" style="width: 180px;" :value="option" @input="val => updatePdfOption(scope.$index, index, val)" />
              </div>
            </div>
            <span v-else style="color: #999; font-style: italic;">{{ scope.row.options ? '简答题' : '无选项' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="knowledge" label="知识点" min-width="180">
          <template slot-scope="scope">
            <el-input v-model="scope.row.knowledge" :placeholder="scope.row.isValid ? '点击上方按钮自动获取或手动填写' : '无'" :disabled="!scope.row.isValid" size="small" />
          </template>
        </el-table-column>
        <el-table-column label="题目类型" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isValid" :type="scope.row.options && scope.row.options.length > 0 ? 'success' : 'warning'">
              {{ scope.row.options && scope.row.options.length > 0 ? '选择题' : '简答题' }}
            </el-tag>
            <el-tag v-else type="danger">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isValid" type="success">有效</el-tag>
            <el-tag v-else type="danger">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isValid" type="text" size="small" @click="previewPdfQuestion(scope.row)" style="color: #409eff;">预览</el-button>
            <el-button type="text" size="small" @click="deletePdfQuestion(scope.$index)" style="color: #f56c6c;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfResultDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePdfResults" :disabled="pdfResults.filter(q => q.selected).length === 0">保存选中题目</el-button>
      </div>
    </el-dialog>

    <!-- table -->
    <div class="table-container">
      <el-table :data="data.records" border fit highlight-current-row :header-cell-style="{
        background: '#f2f3f4',
        color: '#555',
        'font-weight': 'bold',
        'line-height': '32px',
      }" v-loading="loading" @selection-change="handleSelectionChange" style="min-width: 2000px;">
        <el-table-column align="center" type="selection" width="55" fixed="left" />
        <el-table-column label="序号" align="center" width="80" fixed="left">
          <template slot-scope="scope">{{ (data.current - 1) * data.size + scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="id" label="ID" align="center" width="80" />
        <el-table-column prop="content" label="题干" align="center" min-width="300" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.content">{{ scope.row.content }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="image" label="图片" align="center" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.image" class="image-cell">
              <el-image
                :src="getImageUrl(splitImageField(scope.row.image)[0])"
                fit="cover"
                style="width: 60px; height: 40px; border-radius: 4px; border: 1px solid #e4e7ed; cursor: pointer;"
                :preview-src-list="splitImageField(scope.row.image).map(u => getImageUrl(u))"
              />
              <div class="image-name" :title="scope.row.image">{{ getImageName(scope.row.image) }}</div>
            </div>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="repoTitle" label="所属题库" align="center" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.repoTitle">{{ scope.row.repoTitle }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column label="题目类型" align="center" width="120">
          <template slot-scope="scope">
            <template v-if="isKangarooRepo()">
              <span v-if="scope.row.type">{{ scope.row.type }}</span>
              <span v-else style="color: #999;">无</span>
            </template>
            <template v-else>
              <span v-if="scope.row.quType == 1">选择题</span>
              <span v-else-if="scope.row.quType == 2">填空题</span>
              <span v-else-if="scope.row.quType == 3">判断题</span>
              <span v-else-if="scope.row.quType == 4">简答题</span>
              <span v-else style="color: #999;">未知</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="optionsStr" label="选项" align="center" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="isKangarooRepo()">
              <div v-if="scope.row.optionsStr" style="display:flex; flex-wrap:wrap; gap:8px; justify-content:center;">
                <div v-for="(opt, idx) in parseKangarooOptionImages(scope.row.optionsStr)" :key="idx" style="text-align:center;">
                  <div style="font-size:12px; color:#606266; margin-bottom:4px;">{{ opt.label }}</div>
                  <el-image
                    v-if="opt.url"
                    :src="opt.url"
                    fit="contain"
                    style="width: 72px; height: 54px; border: 1px solid #f0f0f0; background:#fff;"
                    :preview-src-list="[opt.url]"
                  />
                  <span v-else style="color:#999;">无</span>
                </div>
              </div>
              <span v-else style="color: #999;">无</span>
            </template>
            <template v-else>
              <span v-if="scope.row.optionsStr">{{ scope.row.optionsStr }}</span>
              <span v-else style="color: #999;">无</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="answer" label="答案" align="center" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.answer">{{ scope.row.answer }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="analysis" label="解析" align="center" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.analysis">{{ scope.row.analysis }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.createTime">{{ scope.row.createTime }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isKangarooRepo()" prop="knowledge" label="知识点" align="center" width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.knowledge">{{ formatKnowledgeNames(scope.row.knowledge) }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isKangarooRepo()" prop="point" label="分数" align="center" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.point">{{ scope.row.point }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isKangarooRepo()" prop="realName" label="录题人" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.realName">{{ scope.row.realName }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isKangarooRepo()" prop="type" label="类型" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type">{{ scope.row.type }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="level" label="难度等级" align="center" width="120">
          <template slot-scope="scope">
            <template v-if="isKangarooRepo()">
              <span v-if="scope.row.level">{{ scope.row.level }}</span>
              <span v-else style="color: #999;">无</span>
            </template>
            <template v-else>
              <el-tag v-if="scope.row.level == 1" type="success">简单</el-tag>
              <el-tag v-else-if="scope.row.level == 2" type="warning">中等</el-tag>
              <el-tag v-else-if="scope.row.level == 3" type="danger">困难</el-tag>
              <span v-else-if="scope.row.level" style="color: #999;">{{ scope.row.level }}</span>
              <span v-else style="color: #999;">无</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="!isKangarooRepo()" prop="url" label="链接" align="center" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.url">{{ scope.row.url }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isKangarooRepo()" prop="difficulty" label="难度系数" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.difficulty">{{ scope.row.difficulty }}</span>
            <span v-else style="color: #999;">无</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" style="font-size: 14px" @click="updateRow(row)">编辑</el-button>
            <el-button type="text" size="small" style="color: red; font-size: 14px" @click="delQu(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="编辑袋鼠题目" :visible.sync="kangarooEditVisible" width="80%">
      <el-form :model="kangarooEditForm" label-width="140px">
        <el-form-item label="题目编号">
          <el-input v-model="kangarooEditForm.questionId" />
        </el-form-item>
        <el-form-item label="英文题干">
          <el-input v-model="kangarooEditForm.originalEnglishQuestion" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="中文题干">
          <el-input v-model="kangarooEditForm.chineseTranslation" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="题目图片(多图)">
          <file-upload-local
            :value="kangarooEditForm.imageArr"
            @input="onKangarooImageArrInput"
            accept="image/*"
            list-type="picture"
            :multiple="true"
            :limit="10"
            action-url="api/file/uploadTo/question-info"
            bucket="question-info"
          />
        </el-form-item>
        <el-form-item label="题目类型">
          <el-input v-model="kangarooEditForm.questionType" />
        </el-form-item>
        <el-form-item label="标签">
          <el-input v-model="kangarooEditForm.questionTags" />
        </el-form-item>
        <el-form-item label="难度等级">
          <el-input v-model="kangarooEditForm.difficultyLevel" />
        </el-form-item>
        <el-form-item label="正确答案">
          <el-input v-model="kangarooEditForm.correctAnswer" />
        </el-form-item>
        <el-form-item label="选项">
          <div>
            <div
              v-for="(opt, idx) in kangarooEditForm.optionsArr"
              :key="idx"
              style="display:flex; gap:6px; margin-bottom: 8px; align-items:center;"
            >
              <span style="width:18px; color:#909399;">{{ String.fromCharCode(65 + idx) }}.</span>
              <el-input v-model="kangarooEditForm.optionsArr[idx]" />
              <file-upload-local
                :value="(kangarooEditForm.optionImagesArr || [])[idx]"
                @input="val => onKangarooEditOptionImagesInput(idx, val)"
                accept="image/*"
                list-type="picture"
                :multiple="true"
                :limit="6"
                action-url="api/file/uploadTo/question-info"
                bucket="question-info"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="英文解析">
          <el-input v-model="kangarooEditForm.englishExplanation" type="textarea" :rows="3" />
          <div style="margin-top: 6px;">
            <file-upload-local
              :value="kangarooEditForm.explainImagesEn"
              @input="val => onKangarooFieldImagesInput('englishExplanation', 'explainImagesEn', val)"
              accept="image/*"
              list-type="picture"
              :multiple="true"
              :limit="10"
              action-url="api/file/uploadTo/question-info"
              bucket="question-info"
            />
          </div>
        </el-form-item>
        <el-form-item label="中文解析">
          <el-input v-model="kangarooEditForm.chineseExplanation" type="textarea" :rows="3" />
          <div style="margin-top: 6px;">
            <file-upload-local
              :value="kangarooEditForm.explainImagesCn"
              @input="val => onKangarooFieldImagesInput('chineseExplanation', 'explainImagesCn', val)"
              accept="image/*"
              list-type="picture"
              :multiple="true"
              :limit="10"
              action-url="api/file/uploadTo/question-info"
              bucket="question-info"
            />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="kangarooEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveKangarooEdit">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination :current-page="data.current" :page-sizes="[10, 20, 30, 40]" :page-size="data.size"
        layout="total, sizes, prev, pager, next, jumper" :total="data.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
    <!--编辑弹窗-->

    <!-- <el-dialog title="编辑" :visible.sync="dialogFormVisible">
      <el-row>
        <el-col :span="12">
          <el-form :model="form">
            <el-form-item label="题干" :label-width="formLabelWidth">
              <el-input v-model="form.content" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form :model="form">
            <el-form-item label="所属题库" :label-width="formLabelWidth">
              <el-input v-model="form.repoTitle" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateQu">确 定</el-button>
      </div>
    </el-dialog> -->

    <!-- 清除知识点对话框 -->
    <el-dialog title="清除知识点" :visible.sync="clearKnowledgeDialogVisible" width="500px">
      <el-alert
        title="警告"
        type="warning"
        description="此操作将清除所选题库的所有知识点数据，且无法恢复！"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;">
      </el-alert>
      <div style="margin-bottom: 15px;">
        <label style="display: block; margin-bottom: 8px; font-weight: bold;">选择题库：</label>
        <RepoSelect v-model="selectedRepoForClearKnowledge" style="width: 100%;" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearKnowledgeDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="confirmClearKnowledge">确认清除</el-button>
      </div>
    </el-dialog>

    <!-- 批量导入知识点对话框 -->
    <el-dialog title="批量导入知识点" :visible.sync="importKnowledgeDialogVisible" width="700px">
      <el-alert
        title="导入说明"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;">
        <div slot="default">
          <p style="margin: 5px 0;">每行一个知识点，使用 <strong>-</strong> 分隔层级关系</p>
          <p style="margin: 5px 0;">示例：</p>
          <p style="margin: 5px 0; padding-left: 20px; color: #409eff;">代数-幂运算-指数运算</p>
          <p style="margin: 5px 0; padding-left: 20px; color: #409eff;">代数-整数与小数巧算</p>
          <p style="margin: 5px 0; padding-left: 20px; color: #409eff;">几何-平面几何-三角形-面积计算</p>
        </div>
      </el-alert>
      <div style="margin-bottom: 15px;">
        <label style="display: block; margin-bottom: 8px; font-weight: bold;">当前题库：</label>
        <el-input :value="$route.query.repoTitle || '全部题库'" disabled />
      </div>
      <div style="margin-bottom: 15px;">
        <label style="display: block; margin-bottom: 8px; font-weight: bold;">知识点列表（每行一个）：</label>
        <el-input
          v-model="knowledgeTextarea"
          type="textarea"
          :rows="10"
          placeholder="请输入知识点，每行一个，使用 - 分隔层级&#10;例如：&#10;代数-幂运算-指数运算&#10;代数-整数与小数巧算&#10;几何-平面几何-三角形">
        </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importKnowledgeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmImportKnowledge">开始导入</el-button>
      </div>
    </el-dialog>

    <!-- 更新知识点(Markdown)对话框 -->
    <el-dialog title="更新知识点 (根据题号)" :visible.sync="updateKnowledgeDialogVisible" width="800px">
      <el-alert
        title="功能说明"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;">
        <div slot="default">
          <p style="margin: 5px 0;">根据题目的 <strong>number</strong> 字段批量更新 <strong>knowledge</strong> 字段</p>
          <p style="margin: 5px 0;">格式：<strong>题号|知识点</strong>，每行一个，知识点使用 <strong>-</strong> 分隔层级</p>
          <p style="margin: 5px 0;">示例：</p>
          <p style="margin: 5px 0; padding-left: 20px; color: #409eff;">1|代数-幂运算-指数运算</p>
          <p style="margin: 5px 0; padding-left: 20px; color: #409eff;">2|代数-整数与小数巧算</p>
          <p style="margin: 5px 0; padding-left: 20px; color: #409eff;">3|几何-平面几何-三角形-面积计算</p>
          <p style="margin: 5px 0; color: #e6a23c;">注意：会先创建知识点（如不存在），然后更新对应题目的knowledge字段</p>
        </div>
      </el-alert>

      <div style="margin-bottom: 15px;">
        <label style="display: block; margin-bottom: 8px; font-weight: bold;">当前题库：</label>
        <repo-select
          v-model="selectedRepoForUpdateKnowledge"
          style="width: 100%"
          @change="handleRepoChangeSingle"
          placeholder="请选择题库" />
      </div>

      <el-tabs v-model="updateKnowledgeMode" style="margin-bottom: 15px;">
        <el-tab-pane label="上传Markdown文件" name="file">
          <div style="margin-bottom: 15px;">
            <label style="display: block; margin-bottom: 8px; font-weight: bold;">选择Markdown文件：</label>
            <el-upload
              ref="updateKnowledgeUpload"
              :auto-upload="false"
              :file-list="updateKnowledgeFileList"
              :on-change="handleUpdateKnowledgeFileChange"
              :on-remove="handleUpdateKnowledgeFileRemove"
              accept=".md,.markdown"
              drag
              :limit="1">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div slot="tip" class="el-upload__tip">只能上传 .md 或 .markdown 文件</div>
            </el-upload>
          </div>
        </el-tab-pane>

        <el-tab-pane label="手动输入" name="manual">
          <div style="margin-bottom: 15px;">
            <label style="display: block; margin-bottom: 8px; font-weight: bold;">题号与知识点映射（每行一个）：</label>
            <el-input
              v-model="updateKnowledgeTextarea"
              type="textarea"
              :rows="12"
              placeholder="请输入题号和知识点，每行一个，格式：题号|知识点&#10;例如：&#10;1|代数-幂运算-指数运算&#10;2|代数-整数与小数巧算&#10;3|几何-平面几何-三角形-面积计算">
            </el-input>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="updateKnowledgeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmUpdateKnowledge">开始更新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { quPaging, quDel, quBatchDel, quUpdate, importQue, quAdd, quDetail, batchUpdateKnowledgeByNumber } from '@/api/question'
import { kangarooQuPaging, kangarooQuDetail, kangarooQuUpdate, kangarooQuDel } from '@/api/kangarooquestion'
import { saveOcrQuestions } from '@/api/amcquestion'
import { parseWordDoc, processOcrImage, processPdfQuestions, getQuestions } from '@/api/ai'
import { clearAllGeneralKnowledge, importKnowledgeFromQuestions, batchEnsureHierarchicalKnowledge, batchEnsureGeneralKnowledge, getGeneralKnowledgeByContent, batchGetGeneralKnowledgeNames, listGeneralKnowledgeTree } from '@/api/knowledge'
import RepoSelect from '@/components/RepoSelect'
import FileUploadLocal from '@/components/FileUpload/local'
import { Loading } from 'element-ui'
import { getTokenInfo } from '@/utils/jwtUtils'

export default {
  components: { RepoSelect, FileUploadLocal },
  data() {
    return {

      loading: false,
      searchName: '',
      selectedRepoSingleSearch: '',
      selectedRepoSingle: '',

      selectedRepoSingleOcrImport: '', // 默认不选择，根据路由参数动态设置

      fileDialogVisible: false,

      ocrImportDialogVisible: false,
      fileList: [],
      selValue: '',
      quTypes: [
        { value: 'choice', label: '选择题' },
        { value: 'fill', label: '填空题' },
        { value: 'judge', label: '判断题' },
        { value: 'application', label: '简答题' }
      ],
      options: [
        {
          value: null,
          label: '全部类型'
        },
        {
          value: 1,
          label: '选择题'
        },
        {
          value: 2,
          label: '填空题'
        },
        {
          value: 3,
          label: '判断题'
        },
        {
          value: 4,
          label: '简答题'
        }],
      length: '',
      pageNum: 1,
      pageSize: 10,
      data: {},
      input: '',
      input1: '',
      formInline: {
        user: '',
        region: ''
      },
      cancle() { },
      dialogTableVisible: false,
      dialogFormVisible: false,
      hasFiles: null,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '110px',
      ocrResultDialogVisible: false,
      ocrResults: [], // 用于存储OCR识别结果
      wordDialogVisible: false,
      wordFileList: [],
      selectedRepoSingleMdImport: '',
      mdResultDialogVisible: false,
      mdResults: [],
      pdfImportDialogVisible: false,
      pdfFileList: [],
      selectedRepoSinglePdfImport: '',
      pdfResultDialogVisible: false,
      pdfResults: [], // 用于存储PDF识别结果
      showManualAddForm: false, // 控制手动添加题目表单显示
      kangarooEditVisible: false,
      kangarooEditForm: {
        id: null,
        repoId: null,
        questionId: '',
        originalEnglishQuestion: '',
        chineseTranslation: '',
        questionType: '',
        questionTags: '',
        difficultyLevel: '',
        correctAnswer: '',
        options: '',
        optionsArr: ['', '', '', '', ''],
        englishExplanation: '',
        chineseExplanation: '',
        image: '',
        imageArr: [],
        contentImagesCn: [],
        contentImagesEn: [],
        explainImagesCn: [],
        explainImagesEn: [],
        optionImages: [],
        optionImagesArr: [[], [], [], [], []]
      },
      newQuestion: { // 新题目数据
        type: 1, // 默认选择题
        stem: '',
        options: ['', ''] // 默认两个选项
      },
      selectedQuestions: [], // 存储选中的试题
      answersFileList: [], // 参考答案文件列表
      clearKnowledgeDialogVisible: false, // 清除知识点对话框
      selectedRepoForClearKnowledge: '', // 清除知识点时选择的题库
      importKnowledgeDialogVisible: false, // 导入知识点对话框
      knowledgeTextarea: '', // 知识点文本域
      updateKnowledgeDialogVisible: false, // 更新知识点对话框
      updateKnowledgeTextarea: '', // 更新知识点的文本域
      updateKnowledgeMode: 'file', // 更新知识点模式：file 或 manual
      updateKnowledgeFileList: [], // 更新知识点的文件列表
      selectedRepoForUpdateKnowledge: '', // 更新知识点时选择的题库
      knowledgeNameMap: {} // id -> name 缓存
    }
  },
  created() {
    // 检查是否有从题库管理页面传递过来的查询参数
    if (this.$route.query.repoId) {
      this.selectedRepoSingleSearch = this.$route.query.repoId
      // 设置导入对话框的默认题库ID
      this.selectedRepoSingle = this.$route.query.repoId
      this.selectedRepoSingleOcrImport = this.$route.query.repoId
      this.selectedRepoSinglePdfImport = this.$route.query.repoId
      this.selectedRepoSingleMdImport = this.$route.query.repoId
      // 如果有题库ID，自动根据该题库ID过滤题目
      console.log('从题库管理页面跳转过来，题库ID:', this.$route.query.repoId)
      console.log('题库名称:', this.$route.query.repoTitle)
      this.initKnowledgeNameMapFromTree(this.$route.query.repoId)
      // 自动根据题库ID获取对应的题目
      this.getQuPage(this.pageNum, this.pageSize, null, this.$route.query.repoId, null)
    } else {
      this.getQuPage()
    }
  },
  methods: {
    isKangarooRepo() {
      const title = String((this.$route && this.$route.query && this.$route.query.repoTitle) || '').toLowerCase()
      return title.includes('袋鼠') || title.includes('kangaroo')
    },

    splitImageField(val) {
      const s = String(val || '').trim()
      if (!s) return []
      return s.split(';').map(x => x.trim()).filter(Boolean)
    },
    joinImageField(arr) {
      const list = Array.isArray(arr) ? arr : []
      return list.map(x => String(x || '').trim()).filter(Boolean).join(';')
    },
    previewUrlToStoredPath(u) {
      const s = String(u || '').trim()
      if (!s) return ''
      if (s.startsWith('/question-info/')) return s
      if (s.startsWith('question-info/')) return '/' + s
      if (s.startsWith('/api/file/preview?path=')) {
        const idx = s.indexOf('path=')
        if (idx > -1) {
          const raw = s.slice(idx + 5)
          try {
            const decoded = decodeURIComponent(raw)
            if (decoded) return decoded
          } catch (e) {
            return ''
          }
        }
      }
      return s
    },
    stripMarkdownImages(text) {
      const s = String(text || '')
      const noImgs = s.replace(/!\[\]\([^\)]*\)\s*/g, '')
      return noImgs.replace(/\n{3,}/g, '\n\n').trim()
    },
    onKangarooImageArrInput(val) {
      const arr = this.normalizeUrlArray(val)
      this.$set(this.kangarooEditForm, 'imageArr', arr)
      this.kangarooEditForm.image = this.joinImageField(arr)
    },

    normalizeUrlArray(val) {
      if (!val) return []
      if (Array.isArray(val)) return val.filter(Boolean)
      return [val].filter(Boolean)
    },
    appendImagesToText(text, urls) {
      let out = String(text || '')
      const arr = this.normalizeUrlArray(urls)
      arr.forEach(u => {
        const url = this.getImageUrl(u)
        if (!url) return
        if (out.includes(url)) return
        out += `\n\n![](${url})`
      })
      return out
    },
    onKangarooFieldImagesInput(targetField, storeField, val) {
      const urls = this.normalizeUrlArray(val)
      this.$set(this.kangarooEditForm, storeField, urls)
      const current = this.kangarooEditForm[targetField] || ''
      this.$set(this.kangarooEditForm, targetField, this.appendImagesToText(current, urls))
    },
    onKangarooOptionImagesInput(val) {
      const urls = this.normalizeUrlArray(val)
      this.kangarooEditForm.optionImages = urls
      const labels = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      const parts = urls.map((u, idx) => {
        const label = labels[idx] || String(idx + 1)
        const url = this.getImageUrl(u)
        return `（对应题目图示选项 ${label}）\n\n![](${url})`
      })
      this.kangarooEditForm.options = parts.join(';')
    },

    parseKangarooOptionsToArray(optionsStr) {
      const s = String(optionsStr || '')
      const parts = s.split(';').map(p => p.trim()).filter(Boolean)
      const out = ['', '', '', '', '']
      for (let i = 0; i < Math.min(5, parts.length); i++) {
        out[i] = parts[i]
      }
      return out
    },
    parseMarkdownImagesFromText(text) {
      const s = String(text || '')
      const urls = []
      const re = /!\[\]\(([^)]+)\)/g
      let m
      while ((m = re.exec(s)) !== null) {
        if (m[1]) urls.push(m[1])
      }
      return urls
    },
    onKangarooEditOptionImagesInput(optIndex, val) {
      const urls = this.normalizeUrlArray(val)
      if (!this.kangarooEditForm.optionImagesArr) {
        this.$set(this.kangarooEditForm, 'optionImagesArr', [[], [], [], [], []])
      }
      this.$set(this.kangarooEditForm.optionImagesArr, optIndex, urls)
      if (!this.kangarooEditForm.optionsArr) {
        this.$set(this.kangarooEditForm, 'optionsArr', ['', '', '', '', ''])
      }
      const curr = this.kangarooEditForm.optionsArr[optIndex] || ''
      this.$set(this.kangarooEditForm.optionsArr, optIndex, this.appendImagesToText(curr, urls))
      this.kangarooEditForm.options = (this.kangarooEditForm.optionsArr || []).join(';')
    },

    parseKangarooOptionImages(optionsStr) {
      const text = String(optionsStr || '')
      const urls = []
      const re = /!\[\]\(([^)]+)\)/g
      let m
      while ((m = re.exec(text)) !== null) {
        if (m[1]) urls.push(m[1])
      }
      const labels = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      return urls.slice(0, 7).map((u, idx) => ({ label: labels[idx] || String(idx + 1), url: u }))
    },

    mapKangarooRecordToCommon(r) {
      // 将袋鼠题目结构映射成页面通用题目结构，避免改动大量模板
      const repoTitle = (this.$route && this.$route.query && this.$route.query.repoTitle) || ''
      return {
        id: r.id,
        repoId: r.repoId,
        repoTitle,
        // 通用页面用 content 展示题干，这里优先中文
        content: r.chineseTranslation || r.originalEnglishQuestion || '',
        image: r.image || '',
        // 通用页面使用 optionsStr/answer/analysis
        optionsStr: r.options || '',
        answer: r.correctAnswer || '',
        analysis: r.chineseExplanation || r.englishExplanation || '',
        // 其它字段尽量兼容
        type: r.questionType || '',
        level: r.difficultyLevel || '',
        uploader: r.uploader || '',
        createTime: r.createTime || ''
      }
    },
    // 获取图片完整URL
    getImageUrl(imageName) {
      if (!imageName) return ''
      // 如果是完整的URL，直接返回
      if (imageName.startsWith('http://') || imageName.startsWith('https://')) {
        return imageName
      }

      // 已经是预览接口地址
      if (imageName.startsWith('/api/file/preview?path=')) {
        return imageName
      }

      // MinIO 预览路径（推荐）
      // 兼容 MinIO 存储路径：/question-info/xxx.png
      if (imageName.startsWith('/question-info/')) {
        return `/api/file/preview?path=${encodeURIComponent(imageName)}`
      }

      if (imageName.startsWith('question-info/')) {
        return `/api/file/preview?path=${encodeURIComponent('/' + imageName)}`
      }

      // 检查是否是本地测试文件
      if (imageName === 'touxiang1.jpg' || imageName === 'touxiang2.jpg') {
        // 对于本地测试文件，直接使用项目根目录的路径
        return `/${imageName}`
      }

      // 其他文件使用MinIO路径
      return `/api/file/question-info/${imageName}`
    },

    // 获取图片名称（用于显示）
    getImageName(imageName) {
      if (!imageName) return ''
      const first = this.splitImageField(imageName)[0] || ''
      if (first && first !== imageName) imageName = first
      // 提取文件名，去掉路径
      const parts = imageName.split('/')
      const fileName = parts[parts.length - 1]
      // 如果文件名太长，截取显示
      if (fileName.length > 10) {
        return fileName.substring(0, 10) + '...'
      }
      return fileName
    },

    // 预览图片
    previewImage(imageName) {
      if (!imageName) {
        this.$message.warning('图片不存在')
        return
      }
      const first = this.splitImageField(imageName)[0] || imageName
      const imageUrl = this.getImageUrl(first)
      console.log('预览图片:', imageUrl)

      // 使用Element UI的图片预览
      this.$alert(`<img src="${imageUrl}" style="max-width: 100%; max-height: 80vh; display: block; margin: 0 auto;" />`, '图片预览', {
        dangerouslyUseHTMLString: true,
        showClose: true,
        showCancelButton: false,
        confirmButtonText: '关闭',
        customClass: 'image-preview-dialog'
      }).catch(() => {})
    },

    // 处理图片加载错误
    handleImageError(event) {
      console.log('图片加载失败:', event.target.src)
      event.target.style.display = 'none'
      // 显示错误占位符
      const placeholder = document.createElement('div')
      placeholder.className = 'image-error-placeholder'
      placeholder.innerHTML = '<i class="el-icon-picture-outline" style="font-size: 20px; color: #c0c4cc;"></i>'
      event.target.parentNode.insertBefore(placeholder, event.target)
    },

    useOcr() {
      if (this.fileList && this.fileList.length > 0 && this.selectedRepoSingleOcrImport !== '') {
        const loadingInstance = Loading.service({
          lock: true,
          text: 'OCR识别中，请稍后...',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 批量处理多张图片
        this.processMultipleImages(loadingInstance)
      } else {
        this.$message.warning('请选择题库和图片后再上传！')
      }
    },

                 // 批量处理多张图片的OCR识别
        async processMultipleImages(loadingInstance) {
          try {
            let allResults = []

            // 逐张处理题目图片
            for (let i = 0; i < this.fileList.length; i++) {
              const file = this.fileList[i]

              // 更新加载提示
              loadingInstance.text = `正在处理第 ${i + 1}/${this.fileList.length} 张题目图片...`

              const formData = new FormData()
              formData.append('image', file.raw) // 每次只发送一张题目图片

              // 添加对应的答案图片（如果有）
              if (this.answersFileList && this.answersFileList.length > 0) {
                // 如果答案图片数量与题目图片数量相同，则一一对应
                if (this.answersFileList.length === this.fileList.length) {
                  formData.append('answers', this.answersFileList[i].raw)
                  console.log(`添加第 ${i + 1} 张答案图片到OCR请求`)
                } else if (this.answersFileList.length === 1) {
                  // 如果只有一张答案图片，则所有题目都使用这张答案图片
                  formData.append('answers', this.answersFileList[0].raw)
                  console.log('添加唯一答案图片到OCR请求')
                } else {
                  formData.append('answers', 'null')
                }
              } else {
                formData.append('answers', 'null')
              }

              try {
                const response = await processOcrImage(formData)
                console.log(`第 ${i + 1} 张图片OCR识别结果：`, response)

                // 修复：正确访问response.data.questions
                const questions = response.data && response.data.questions ? response.data.questions : response.questions

                if (questions && Array.isArray(questions)) {
                  // 处理返回的题目数据，为每个题目添加来源图片信息
                  const processedQuestions = questions.map((question, index) => {
                    // 确保options字段存在且为数组
                    let options = question.options || []
                    if (typeof options === 'string') {
                      try {
                        options = JSON.parse(options)
                      } catch (e) {
                        options = []
                      }
                    }

                    return {
                      content: question.question_content || question.content || '',
                      answer: question.answer || '',
                      options: options,
                      knowledge: '',
                      analysis: question.explanation || question.analysis || '',
                      type: this.getQuestionType(question.question_type || question.type),
                      sourceImage: file.name // 记录来源图片名称
                    }
                  })

                  allResults = allResults.concat(processedQuestions)
                } else {
                  console.error(`第 ${i + 1} 张图片返回的数据格式不正确：`, response)
                }
              } catch (error) {
                console.error(`第 ${i + 1} 张图片处理失败：`, error)
                // 继续处理下一张图片，不中断整个流程
              }
            }

            loadingInstance.close()

            if (allResults.length > 0) {
              this.ocrResults = allResults
              this.$message.success(`OCR识别完成！共识别出 ${this.ocrResults.length} 道题目`)
              console.log('设置 ocrResultDialogVisible = true')
              console.log('ocrResults 数据:', this.ocrResults)
              this.ocrImportDialogVisible = false

              // 直接显示结果弹窗
              this.ocrResultDialogVisible = true
              console.log('弹窗状态:', this.ocrResultDialogVisible)

              // 延迟关闭OCR导入弹窗
              setTimeout(() => {
                this.ocrImportDialogVisible = false
              }, 200)
            } else {
              this.$message.error('所有图片识别失败，请检查图片质量或稍后重试')
            }
          } catch (error) {
            loadingInstance.close()
            console.error('批量OCR识别失败：', error)
            this.$message.error('批量OCR识别失败：' + (error.message || '未知错误'))
          }
        },
    test() {
      const repoId = this.$route.query.repoId || this.selectedRepoSingleSearch || this.selectedRepoSingle || this.selectedRepoSingleMdImport
      const repoTitle = this.$route.query.repoTitle || ''
      const title = String(repoTitle || '').toLowerCase()
      // 袋鼠题库跳转到袋鼠专用录题页；否则默认跳转 AMC 录题页
      const targetPath = (title.includes('袋鼠') || title.includes('kangaroo'))
        ? '/questions-kangaroo-add'
        : '/questions-amc-add'
      this.$router.push({
        path: targetPath,
        query: Object.assign({}, repoId ? { repoId } : {}, repoTitle ? { repoTitle } : {})
      })
    },
    handleRepoChangeSingle(repo) {
      console.log('单选题库变化:', repo)
    },
    updateRow(row) {
      console.log('开始编辑题目:', row)
      console.log('题目ID:', row.id)

      if (!row.id) {
        this.$message.error('题目ID不存在，无法编辑')
        return
      }

      if (this.isKangarooRepo()) {
        this.openKangarooEdit(row.id)
        return
      }

      try {
        localStorage.setItem('quId', row.id)
        console.log('题目ID已保存到localStorage:', row.id)

        this.$router.push({ name: 'questions-add' })
        console.log('正在跳转到编辑页面...')
      } catch (error) {
        console.error('编辑题目失败:', error)
        this.$message.error('编辑题目失败：' + (error.message || '未知错误'))
      }
    },

    async openKangarooEdit(id) {
      try {
        const res = await kangarooQuDetail(id)
        if (!res || res.code !== 1) {
          this.$message.error((res && res.msg) || '获取题目详情失败')
          return
        }
        const q = res.data || {}
        const optionsArr = this.parseKangarooOptionsToArray(q.options || '')
        const optionImagesArr = optionsArr.map(t => this.parseMarkdownImagesFromText(t))

        const stemImgs = this.parseMarkdownImagesFromText(q.chineseTranslation || '')
        const cleanedCnStem = this.stripMarkdownImages(q.chineseTranslation || '')
        const imgFromField = this.splitImageField(q.image || '')
        const mergedImages = [...imgFromField, ...stemImgs.map(u => this.previewUrlToStoredPath(u))]
          .map(x => String(x || '').trim())
          .filter(Boolean)
        const imageArr = Array.from(new Set(mergedImages))

        this.kangarooEditForm = {
          id: q.id,
          repoId: q.repoId,
          questionId: q.questionId || '',
          originalEnglishQuestion: q.originalEnglishQuestion || '',
          chineseTranslation: cleanedCnStem,
          questionType: q.questionType || '',
          questionTags: q.questionTags || '',
          difficultyLevel: q.difficultyLevel || '',
          correctAnswer: q.correctAnswer || '',
          options: q.options || '',
          optionsArr,
          englishExplanation: q.englishExplanation || '',
          chineseExplanation: q.chineseExplanation || '',
          image: this.joinImageField(imageArr),
          imageArr,
          contentImagesCn: [],
          contentImagesEn: [],
          explainImagesCn: [],
          explainImagesEn: [],
          optionImages: [],
          optionImagesArr
        }
        this.kangarooEditVisible = true
      } catch (e) {
        console.error('[openKangarooEdit] failure:', e)
        this.$message.error('获取题目详情失败：' + ((e && e.message) || '未知错误'))
      }
    },

    async saveKangarooEdit() {
      try {
        if (!this.kangarooEditForm || !this.kangarooEditForm.id) {
          this.$message.error('缺少题目ID')
          return
        }
        const id = this.kangarooEditForm.id
        const payload = {
          repoId: this.kangarooEditForm.repoId,
          questionId: this.kangarooEditForm.questionId,
          originalEnglishQuestion: this.kangarooEditForm.originalEnglishQuestion,
          chineseTranslation: this.kangarooEditForm.chineseTranslation,
          questionType: this.kangarooEditForm.questionType,
          questionTags: this.kangarooEditForm.questionTags,
          difficultyLevel: this.kangarooEditForm.difficultyLevel,
          correctAnswer: this.kangarooEditForm.correctAnswer,
          options: this.kangarooEditForm.options,
          englishExplanation: this.kangarooEditForm.englishExplanation,
          chineseExplanation: this.kangarooEditForm.chineseExplanation,
          image: this.kangarooEditForm.image
        }
        const res = await kangarooQuUpdate(id, payload)
        if (!res || res.code !== 1) {
          this.$message.error((res && res.msg) || '保存失败')
          return
        }
        this.$message.success('保存成功')
        this.kangarooEditVisible = false
        this.getQuPage(this.pageNum, this.pageSize, this.searchName, this.selectedRepoSingleSearch, this.selValue)
      } catch (e) {
        console.error('[saveKangarooEdit] failure:', e)
        this.$message.error('保存失败：' + ((e && e.message) || '未知错误'))
      }
    },
    importQu() {
      if (this.fileList && this.fileList.length > 0 && this.selectedRepoSingle !== '') {
        const formData = new FormData()
        formData.append('file', this.fileList[0].raw)
        importQue(this.selectedRepoSingle, formData)
          .then((response) => {
            if (response.code) {
              this.$message.success('导入成功！')
              this.getQuPage(this.pageNum, this.pageSize)
              this.fileDialogVisible = false
              this.selectedRepoSingle = ''
              this.fileList = []
            } else {
              this.$message({
                type: 'error',
                message: response.msg
              })
              this.fileList = []
            }
          })
          .catch((error) => {
            console.error('文件上传失败：', error)
            this.$message.error('文件上传失败！')
            this.fileList = []
          })
      } else {
        this.$message.warning('请选择文件后再上传！')
      }
    },

    handleFileChange(file, fileList) {
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      if (fileList.length === 0) {
        this.hasFiles = false
      }
    },
    handleAnswersFileChange(file, fileList) {
      this.answersFileList = fileList
    },
    handleAnswersFileRemove(file, fileList) {
      this.answersFileList = fileList
    },

    // 根据题目ID查询完整信息
    async enrichQuestionDetails() {
      try {
        const enrichedRecords = []

        for (const record of this.data.records) {
          if (record.id) {
            try {
              console.log(`正在查询题目ID ${record.id} 的完整信息...`)
              const detailResponse = await quDetail(record.id)

              if (detailResponse && detailResponse.code === 1 && detailResponse.data) {
                const detailData = detailResponse.data
                console.log(`题目ID ${record.id} 的完整信息:`, detailData)

                // 合并分页数据和详情数据，优先使用详情数据
                const enrichedRecord = {
                  ...record, // 保留分页数据
                  ...detailData, // 用详情数据覆盖
                  // 确保关键字段存在
                  id: detailData.id || record.id,
                  content: detailData.content || record.content || '',
                  image: detailData.image || record.image || '',
                  repoTitle: detailData.repoTitle || record.repoTitle || '',
                  quType: detailData.quType || record.quType || 1,
                  optionsStr: detailData.optionsStr || record.optionsStr || '',
                  answer: detailData.answer || record.answer || '',
                  analysis: detailData.analysis || record.analysis || '',
                  createTime: detailData.createTime || record.createTime || '',
                  knowledge: detailData.knowledge || record.knowledge || '',
                  point: detailData.point || record.point || 10,
                  realName: detailData.realName || record.realName || '',
                  type: detailData.type || record.type || '',
                  level: detailData.level || record.level || 1,
                  url: detailData.url || record.url || '',
                  difficulty: detailData.difficulty || record.difficulty || 0.5
                }

                enrichedRecords.push(enrichedRecord)
                console.log(`题目ID ${record.id} 信息已丰富`)
              } else {
                console.warn(`题目ID ${record.id} 查询详情失败，使用原始数据`)
                enrichedRecords.push(record)
              }
            } catch (error) {
              console.error(`查询题目ID ${record.id} 详情失败:`, error)
              enrichedRecords.push(record) // 使用原始数据作为备选
            }
          } else {
            console.warn('题目缺少ID，跳过详情查询:', record)
            enrichedRecords.push(record)
          }
        }

        // 更新数据
        this.data.records = enrichedRecords
        console.log('题目信息丰富完成，最终数据:', this.data.records)

        // 检查第一条记录的完整性
        if (enrichedRecords.length > 0) {
          console.log('第一条题目完整数据示例:', enrichedRecords[0])
          console.log('数据字段检查:')
          const firstRecord = enrichedRecords[0]
          console.log('- id:', firstRecord.id)
          console.log('- content:', firstRecord.content)
          console.log('- image:', firstRecord.image)
          console.log('- repoTitle:', firstRecord.repoTitle)
          console.log('- quType:', firstRecord.quType)
          console.log('- optionsStr:', firstRecord.optionsStr)
          console.log('- answer:', firstRecord.answer)
          console.log('- analysis:', firstRecord.analysis)
          console.log('- createTime:', firstRecord.createTime)
          console.log('- knowledge:', firstRecord.knowledge)
          console.log('- point:', firstRecord.point)
          console.log('- realName:', firstRecord.realName)
          console.log('- type:', firstRecord.type)
          console.log('- level:', firstRecord.level)
          console.log('- url:', firstRecord.url)
          console.log('- difficulty:', firstRecord.difficulty)
        }
      } catch (error) {
        console.error('丰富题目详情失败:', error)
        this.$message.warning('获取题目详情失败，显示基础信息')
      }
    },

                   // 删除单张图片
          removeFile(index) {
            this.fileList.splice(index, 1)
            this.$message.success('图片已删除')
          },
    async getQuPage(pageNum, pageSize, content = null, repoId = null, type = null) {
      this.loading = true
      const params = {
        pageNum: pageNum || 1,
        pageSize: pageSize || 10,
        content: content,
        repoId: repoId,
        type: type
      }
      console.log('请求参数:', params)
      try {
        const res = this.isKangarooRepo()
          ? await kangarooQuPaging({
            pageNum: params.pageNum,
            pageSize: params.pageSize,
            keyword: params.content,
            repoId: params.repoId
          })
          : await quPaging(params)
        console.log('原始响应数据:', res)
        if (!res) {
          console.error('API返回数据为空')
          this.$message.error('获取数据失败：API返回数据为空')
          return
        }
        if (res.code !== 1) {
          console.error('API返回错误:', res.msg)
          this.$message.error(res.msg || '获取数据失败')
          return
        }
        if (!res.data) {
          console.error('API返回数据格式错误：缺少data字段')
          this.$message.error('获取数据失败：API返回数据格式错误')
          return
        }
        this.data = res.data
        console.log('赋值后的 this.data:', this.data)

        if (!this.isKangarooRepo() && params.repoId) {
          this.initKnowledgeNameMapFromTree(params.repoId)
        }

        // 袋鼠题库：将 records 映射为通用字段，并跳过 enrich（否则会请求 /questions/single/{id}）
        if (this.isKangarooRepo() && this.data && Array.isArray(this.data.records)) {
          this.data.records = this.data.records.map(this.mapKangarooRecordToCommon)
        }

        // 根据题目ID查询完整信息
        if (!this.isKangarooRepo() && this.data.records && this.data.records.length > 0) {
          console.log('开始根据ID查询题目完整信息...')
          await this.enrichQuestionDetails()
        }
        console.log('this.data.records:', this.data.records)
        console.log('this.data.records 长度:', this.data.records ? this.data.records.length : 0)

        // 批量加载知识点名称
        await this.loadKnowledgeNames()
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败：' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },

    flattenKnowledgeTreeToMap(nodes, map) {
      const list = Array.isArray(nodes) ? nodes : []
      list.forEach(n => {
        if (n && n.id != null && n.content != null) {
          map[String(n.id)] = String(n.content)
        }
        if (n && Array.isArray(n.children) && n.children.length) {
          this.flattenKnowledgeTreeToMap(n.children, map)
        }
      })
    },

    async initKnowledgeNameMapFromTree(repoId) {
      const rid = repoId == null || repoId === '' ? null : Number(repoId)
      if (!rid) return
      try {
        const res = await listGeneralKnowledgeTree(rid)
        if (!res || res.code !== 1) return
        const tree = res.data || []
        const map = {}
        this.flattenKnowledgeTreeToMap(tree, map)
        this.knowledgeNameMap = { ...this.knowledgeNameMap, ...map }
      } catch (e) {
        console.warn('加载知识点树失败:', e)
      }
    },

    async loadKnowledgeNames() {
      const records = (this.data && this.data.records) || []
      const ids = new Set()
      records.forEach(r => {
        if (r.knowledge) {
          String(r.knowledge).split(',').map(s => s.trim()).filter(Boolean).forEach(id => ids.add(Number(id)))
        }
      })
      const newIds = Array.from(ids).filter(id => !this.knowledgeNameMap[id])
      if (!newIds.length) return
      try {
        const res = await batchGetGeneralKnowledgeNames(newIds)
        const map = res?.data || {}
        const updated = { ...this.knowledgeNameMap }
        Object.entries(map).forEach(([id, name]) => { updated[id] = name })
        this.knowledgeNameMap = updated
      } catch (e) {
        console.warn('批量获取知识点名称失败:', e)
      }
    },

    formatKnowledgeNames(knowledge) {
      if (!knowledge) return ''
      return String(knowledge).split(',').map(s => s.trim()).filter(Boolean)
        .map(id => this.knowledgeNameMap[id] || id)
        .join(' / ')
    },
    updateQu() {
      quUpdate(this.form.id, { title: this.form.title })
        .then((res) => {
          if (res.code) {
            this.getQuPage(
              this.pageNum,
              this.pageSize,
              this.searchName,
              this.selectedRepoSingleSearch,
              this.selValue
            )
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: '编辑成功!'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消编辑'
          })
        })
    },
    delQu(row) {
      this.$confirm('此操作将永久删除该试题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
        })
        .then(() => {
          const api = this.isKangarooRepo() ? kangarooQuDel : quDel
          api(row.id).then((res) => {
            if (res && res.code) {
              this.getQuPage(
                this.pageNum,
                this.pageSize,
                this.searchName,
                this.selectedRepoSingleSearch,
                this.selValue
              )
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              this.$message.error((res && res.msg) || '删除失败')
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    searchQu() {
      this.getQuPage(
        this.pageNum,
        this.pageSize,
        this.searchName,
        this.selectedRepoSingleSearch,
        this.selValue
      )
    },
    screenInfo(row, index, done) {
      this.$router.push({ name: 'questions-add', query: { zhi: row } })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getQuPage(this.pageNum, val, this.searchName, this.selectedRepoSingleSearch, this.selValue)
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getQuPage(val, this.pageSize, this.searchName, this.selectedRepoSingleSearch, this.selValue)
    },
    async startDownload() {
      const a = document.createElement('a')
      a.href = './template/ImportQuestionTemplate.xlsx'
      a.download = '导入试题模板.xlsx'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    deleteRow(index) {
      this.ocrResults.splice(index, 1)
    },
    addOption(questionIndex) {
      if (!this.ocrResults[questionIndex].options) {
        this.$set(this.ocrResults[questionIndex], 'options', [])
      }
      const optionLabel = String.fromCharCode(65 + this.ocrResults[questionIndex].options.length)
      this.ocrResults[questionIndex].options.push(`(${optionLabel})`)
    },
    removeOption(questionIndex, optionIndex) {
      this.ocrResults[questionIndex].options.splice(optionIndex, 1)
    },
                   getQuestionType(questionType) {
            const typeMap = {
              'multiple_choice': 'choice',
              'single_choice': 'choice',
              'choice': 'choice',
              'fill_blank': 'fill',
              'fill': 'fill',
              'true_false': 'judge',
              'judge': 'judge',
              'essay': 'application',
              'application': 'application'
            }
            return typeMap[questionType] || 'application'
          },
    previewQuestion(question) {
      let previewContent = `题目内容：${question.content}\n\n`

      if (question.options && question.options.length > 0) {
        previewContent += `选项：\n`
        question.options.forEach((option, index) => {
          previewContent += `${String.fromCharCode(65 + index)}. ${option}\n`
        })
        previewContent += '\n'
      }

      previewContent += `答案：${question.answer}\n\n`
      previewContent += `解析：${question.analysis || '无'}\n\n`
      previewContent += `知识点：${question.knowledge || '无'}`

      this.$alert(previewContent, '题目预览', {
        confirmButtonText: '确定',
        customClass: 'preview-dialog'
      })
    },
    getQuestionTypeCount(type) {
      return this.ocrResults.filter(item => item.type === type).length
    },
    async saveOcrResults() {
      // 根据来源确定使用哪个题库ID
      const repoId = this.selectedRepoSingleOcrImport

      if (!repoId) {
        this.$message.error('请选择题库')
        return
      }

      const loadingInstance = Loading.service({
        lock: true,
        text: '正在保存题目...',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        // 获取当前用户信息
        const userInfo = getTokenInfo()
        const realName = userInfo ? userInfo.realName : ''

        const saveData = this.ocrResults.map(item => ({
          repoId: repoId,
          content: item.content,
          answer: item.answer,
          options: item.options && item.options.length > 0 ? item.options.join(';') : '', // 将数组转换为分号分隔的字符串
          analysis: item.analysis,
          knowledge: item.knowledge,
          quType: this.convertQuType(item.type),
          version: '人教版',
          difficulty: 0.5,
          level: 2
          // realName字段由后端根据当前登录用户自动设置，前端不需要发送
        }))

        console.log('保存的题目数据：', saveData)

        const response = await saveOcrQuestions(saveData)

        if (response.code === 1) {
          this.$message.success(response.msg || '保存成功！')
          this.ocrResultDialogVisible = false
          this.ocrResults = []
          this.fileList = []
          this.answersFileList = []
          this.getQuPage(this.pageNum, this.pageSize)
        } else {
          this.$message.error(response.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败：', error)
        this.$message.error('保存失败，请稍后重试')
      } finally {
        loadingInstance.close()
      }
    },
    convertQuType(type) {
      const typeMap = {
        'choice': 1,
        'fill': 2,
        'judge': 3,
        'application': 4
      }
      return typeMap[type] || 4
    },
    handleWordFileChange(file, fileList) {
      this.wordFileList = fileList.slice(-1)
    },
    handleWordFileRemove(file, fileList) {
      this.wordFileList = fileList
    },
    async submitWordFile() {
      if (!this.wordFileList.length) {
        this.$message.warning('请先上传Word文件')
        return
      }
      const formData = new FormData()
      formData.append('word_file', this.wordFileList[0].raw)
      try {
        const res = await parseWordDoc(formData)
        this.$message.success('上传成功')
        this.wordDialogVisible = false
        this.wordFileList = []
        console.log('解析结果:', res.data)
      } catch (e) {
        this.$message.error('上传失败')
        console.error(e)
      }
    },
    // Markdown 导入相关方法
    async submitMarkdownFile() {
      const repoId = this.selectedRepoSingleMdImport || this.$route.query.repoId
      if (!repoId) {
        this.$message.warning('请先选择题库')
        return
      }
      if (!this.wordFileList || this.wordFileList.length === 0) {
        this.$message.warning('请先选择 Markdown 文件')
        return
      }
      try {
        const formData = new FormData()
        formData.append('md_file', this.wordFileList[0].raw)
        const resp = await getQuestions(formData)
        const payload = (resp && resp.data) || resp || {}
        const arr = Array.isArray(payload)
          ? payload
          : (payload.data || payload.results || payload.questions || payload.problems || [])
        // 转换为统一格式（保留 Kangaroo 返回的所有字段）
        this.mdResults = (Array.isArray(arr) ? arr : []).map((item, idx) => {
          const rawOptions = Array.isArray(item.options)
            ? item.options
            : (Array.isArray(item.choices) ? item.choices : [])
          const options = rawOptions.map(opt => this.normalizeOptionText(opt))
          const correctAnswer = (item.correct_answer || item.correctAnswer || item.answer || '').toString().trim()

          return {
            index: idx + 1,
            selected: true,

            // Kangaroo fields
            questionId: item.question_id || item.questionId || '',
            englishQuestion: item.original_english_question || item.english_question || item.stem_en || item.englishQuestion || '',
            chineseQuestion: item.chinese_translation || item.content || item.question || item.stem || item.content_cn || item.contentCn || '',
            questionType: item.question_type || item.type || '',
            tags: item.question_tags || (Array.isArray(item.tags) ? item.tags.join(',') : (item.tags || item.knowledge || '')),
            difficultyLevelText: item.difficulty_level || item.difficultyLevel || '',
            englishExplanation: item.english_explanation || item.analysis_en || item.englishExplanation || '',
            chineseExplanation: item.chinese_explanation || item.analysis || item.analysis_cn || item.analysisCn || '',
            correctAnswer: correctAnswer,

            // normalized for saving
            options,
            quType: options.length > 0 ? 1 : 4
          }
        })
        this.wordDialogVisible = false
        this.wordFileList = []
        this.mdResultDialogVisible = true
        this.$message.success(`成功解析 ${this.mdResults.length} 道题目`)
      } catch (e) {
        const msg = (e && e.response && e.response.data && (e.response.data.msg || e.response.data.message)) ||
          (e && e.message) ||
          '未知错误'
        console.error('[submitMarkdownFile] failure:', e)
        this.$message.error('Markdown解析失败：' + msg)
      }
    },
    getMdChoiceCount() {
      return this.mdResults.filter(q => q.options && q.options.length > 0).length
    },
    getMdEssayCount() {
      return this.mdResults.filter(q => !q.options || q.options.length === 0).length
    },
    selectAllMdQuestions() {
      this.mdResults.forEach(q => { q.selected = true })
    },
    deselectAllMdQuestions() {
      this.mdResults.forEach(q => { q.selected = false })
    },
    deleteSelectedMdQuestions() {
      this.mdResults = this.mdResults.filter(q => !q.selected)
    },
    deleteMdQuestion(index) {
      this.mdResults.splice(index, 1)
    },
    normalizeOptionText(opt) {
      const s = (opt == null ? '' : String(opt)).trim()
      return s
        .replace(/^\(?[A-Ea-e]\)?\s*[\.:、\)]\s*/g, '')
        .replace(/^\(?[A-Ea-e]\)\s*/g, '')
        .trim()
    },
    parseKangarooLevelText(text) {
      const s = (text || '').toString().trim()
      const m = s.match(/Level\s*([A-Z])/i)
      if (!m) return null
      const ch = m[1].toUpperCase()
      const code = ch.charCodeAt(0) - 64
      return Number.isFinite(code) && code > 0 ? code : null
    },
    async saveMdResults() {
      const repoId = this.selectedRepoSingleMdImport || this.$route.query.repoId
      if (!repoId) {
        this.$message.warning('请先选择题库')
        return
      }
      const selectedQuestions = this.mdResults.filter(q => q.selected)
      if (selectedQuestions.length === 0) {
        this.$message.warning('请至少选择一道题目')
        return
      }
      try {
        const userInfo = getTokenInfo()
        for (const q of selectedQuestions) {
          const level = this.parseKangarooLevelText(q.difficultyLevelText)
          const evaluatePayload = {
            question_id: q.questionId,
            original_english_question: q.englishQuestion,
            english_explanation: q.englishExplanation,
            chinese_translation: q.chineseQuestion,
            chinese_explanation: q.chineseExplanation,
            question_type: q.questionType,
            question_tags: q.tags,
            difficulty_level: q.difficultyLevelText
          }
          const questionData = {
            repoId: repoId,
            quType: q.quType || 1,
            // 后端字段
            content: q.chineseQuestion || q.englishQuestion || '',
            answer: q.correctAnswer || '',
            analysis: q.chineseExplanation || '',
            evaluate: JSON.stringify(evaluatePayload),
            knowledge: q.tags || '',
            type: q.questionType || '',
            level: level,
            options: q.options && q.options.length > 0 ? q.options.map((opt, idx) => ({
              content: opt,
              isRight: (q.correctAnswer || '').toString().toUpperCase().includes(String.fromCharCode(65 + idx))
            })) : [],
            createBy: userInfo ? userInfo.id : null
          }
          await quAdd(questionData)
        }
        this.$message.success(`成功保存 ${selectedQuestions.length} 道题目`)
        this.mdResultDialogVisible = false
        this.mdResults = []
        this.getQuPage(this.pageNum, this.pageSize)
      } catch (e) {
        console.error('保存题目失败:', e)
        this.$message.error('保存题目失败：' + (e.message || '未知错误'))
      }
    },
    // 处理粘贴图片
    handlePasteImage() {
      // 尝试从剪贴板读取图片
      if (navigator.clipboard && navigator.clipboard.read) {
        navigator.clipboard.read().then(items => {
          for (const item of items) {
            if (item.types.includes('image/png') || item.types.includes('image/jpeg')) {
              item.getType('image/png').then(blob => {
                this.processClipboardImage(blob)
              }).catch(() => {
                // 如果获取PNG失败，尝试获取JPEG
                if (item.types.includes('image/jpeg')) {
                  item.getType('image/jpeg').then(blob => {
                    this.processClipboardImage(blob)
                  })
                }
              })
              return
            }
          }
          this.$message.warning('剪贴板中没有找到图片，请先复制截图')
        }).catch(() => {
          this.$message.error('无法访问剪贴板，请手动上传图片')
        })
      } else {
        this.$message.warning('当前浏览器不支持剪贴板API，请手动上传图片')
      }
    },
                 // 处理剪贴板图片
         processClipboardImage(blob) {
           // 创建文件对象
           const file = new File([blob], `paste-image-${Date.now()}.png`, {
             type: blob.type || 'image/png'
           })

                   // 检查文件大小（2MB限制）
           if (file.size > 2 * 1024 * 1024) {
             this.$message.error('图片大小不能超过2MB')
             return
           }

           // 检查文件数量限制
           if (this.fileList.length >= 10) {
             this.$message.warning('最多只能上传10张图片')
             return
           }

           // 创建文件列表项
           const fileItem = {
             name: file.name,
             size: file.size,
             type: file.type,
             raw: file,
             status: 'ready',
             uid: Date.now()
           }

           // 添加到文件列表（而不是替换）
           this.fileList.push(fileItem)
           this.$message.success(`截图粘贴成功！当前共 ${this.fileList.length} 张图片`)
         },
    // 键盘事件处理
    handleKeydown(event) {
      // 检查是否在OCR导入对话框中且按下了Ctrl+V
      if (this.ocrImportDialogVisible && event.ctrlKey && event.key === 'v') {
        event.preventDefault()
        this.handlePasteImage()
      }
    },
    // PDF文件上传处理
    handlePdfFileChange(file, fileList) {
      this.pdfFileList = fileList
    },
    handlePdfFileRemove(file, fileList) {
      this.pdfFileList = fileList
    },
    // 提交PDF文件
    async submitPdfFile() {
      if (!this.selectedRepoSinglePdfImport) {
        this.$message.error('请选择题库')
        return
      }
      if (this.pdfFileList.length === 0) {
        this.$message.error('请选择PDF文件')
        return
      }

      const loadingInstance = Loading.service({
        lock: true,
        text: '正在处理PDF文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const file = this.pdfFileList[0].raw
        const formData = new FormData()
        formData.append('pdf_file', file)

        // 调用API处理PDF
        const response = await processPdfQuestions(formData)

        if (response.status === 'success') {
          // 处理返回的题目数据，添加额外属性用于界面展示
          this.pdfResults = response.questions.map(question => ({
             ...question,
             isValid: question.stem && question.stem !== 'null' && question.stem.trim() !== '',
             selected: question.stem && question.stem !== 'null' && question.stem.trim() !== '', // 默认选中有效题目
             options: question.options ? question.options : null, // 保留原始选项格式，不移除标识符
             difficulty: question.difficulty || 0.5 // 添加难度字段，默认值为0.5
           }))

           const validCount = this.pdfResults.filter(q => q.isValid).length
           if (validCount === 0) {
             this.$message.warning('PDF处理完成，但未识别到有效题目，请手动添加题目内容')
             // 当没有识别到有效题目时，自动显示手动添加表单
             this.showManualAddForm = true
           } else {
             this.$message.success(`PDF处理完成！识别到 ${response.questions.length} 道题目，其中有效题目 ${validCount} 道`)
           }

          this.pdfImportDialogVisible = false
          this.pdfResultDialogVisible = true
        } else {
          this.$message.error('PDF处理失败')
        }
      } catch (error) {
        console.error('PDF处理错误:', error)
        this.$message.error('PDF处理失败：' + (error.message || '未知错误'))
      } finally {
        loadingInstance.close()
      }
    },
    // PDF识别结果相关方法
    getPdfValidCount() {
      return this.pdfResults.filter(q => q.isValid).length
    },
    getPdfInvalidCount() {
      return this.pdfResults.filter(q => !q.isValid).length
    },
    getPdfChoiceCount() {
      return this.pdfResults.filter(q => q.isValid && q.options && q.options.length > 0).length
    },
    getPdfEssayCount() {
      return this.pdfResults.filter(q => q.isValid && (!q.options || q.options.length === 0)).length
    },
    selectAllValidPdfQuestions() {
      this.pdfResults.forEach(question => {
        if (question.isValid) {
          question.selected = true
        }
      })
    },
    deselectAllPdfQuestions() {
      this.pdfResults.forEach(question => {
        question.selected = false
      })
    },
    deleteSelectedPdfQuestions() {
      this.pdfResults = this.pdfResults.filter(q => !q.selected)
      this.$message.success('已删除选中的题目')
    },
    deletePdfQuestion(index) {
      this.pdfResults.splice(index, 1)
      this.$message.success('题目已删除')
    },
    updatePdfOption(questionIndex, optionIndex, value) {
      this.pdfResults[questionIndex].options[optionIndex] = value
    },
    previewPdfQuestion(question) {
      let previewContent = `题目内容：\n${question.stem}\n\n`

      if (question.options && question.options.length > 0) {
        previewContent += '选项：\n'
        question.options.forEach((option, index) => {
          previewContent += `${String.fromCharCode(65 + index)}. ${option}\n`
        })
      }

      this.$alert(previewContent, '题目预览', {
        confirmButtonText: '确定',
        customClass: 'preview-dialog'
      })
    },
    // 暂时占位：获取知识点按钮不执行任何操作
    noopKnowledgeFetch() {
      // no-op
    },
    async savePdfResults() {
      const selectedQuestions = this.pdfResults.filter(q => q.selected)

      if (selectedQuestions.length === 0) {
        this.$message.warning('请选择要保存的题目')
        return
      }

      const loadingInstance = Loading.service({
        lock: true,
        text: '正在保存题目...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let savedCount = 0
      let failedCount = 0

      try {
        // 获取用户信息
        const userInfo = getTokenInfo()

        // 构建批量保存的数据
        const questionsData = selectedQuestions.map((question) => {
          const questionData = {
            content: question.stem,
            options: question.options && question.options.length > 0 ? question.options.join(';') : '', // 将数组转换为分号分隔的字符串
            quType: question.options && question.options.length > 0 ? 1 : 4, // 有选项的是选择题，无选项的是简答题
            repoId: this.selectedRepoSinglePdfImport,
            level: 1, // 默认普通难度
            analysis: '',
            evaluate: '',
            difficulty: question.difficulty || 0.5 // 添加难度字段
          }

          // 添加录题人信息
          // realName字段由后端根据当前登录用户自动设置，前端不需要发送
          // if (userInfo && userInfo.realName) {
          //   questionData.realName = userInfo.realName
          // }

          return questionData
        })

        // 使用批量保存接口
        try {
          const response = await saveOcrQuestions(questionsData)
          if (response.code === 1) {
            savedCount = selectedQuestions.length
            failedCount = 0
          } else {
            savedCount = 0
            failedCount = selectedQuestions.length
          }
        } catch (error) {
          console.error('批量保存题目失败:', error)
          savedCount = 0
          failedCount = selectedQuestions.length
        }

        // 显示保存结果
        const successMessage = `题目保存完成！\n` +
          `选择题目: ${selectedQuestions.length}\n` +
          `成功保存: ${savedCount}\n` +
          `保存失败: ${failedCount}`

        this.$message.success(successMessage)
        this.pdfResultDialogVisible = false
        this.pdfFileList = []
        this.selectedRepoSinglePdfImport = ''
        this.pdfResults = []
        this.getQuPage() // 刷新题目列表
      } catch (error) {
        console.error('保存题目时发生错误:', error)
        this.$message.error('保存题目时发生错误：' + (error.message || '未知错误'))
      } finally {
        loadingInstance.close()
      }
    },
    // 显示手动添加题目表单
    showAddQuestionForm() {
      this.showManualAddForm = true
      this.resetNewQuestion()
    },
    // 取消添加题目
    cancelAddQuestion() {
      this.showManualAddForm = false
      this.resetNewQuestion()
    },
    // 重置新题目数据
    resetNewQuestion() {
      this.newQuestion = {
        type: 1,
        stem: '',
        options: ['', '']
      }
    },
    // 添加选项
    addManualOption() {
      if (this.newQuestion.options.length < 6) {
        this.newQuestion.options.push('')
      }
    },
    // 删除选项
    removeManualOption(index) {
      if (this.newQuestion.options.length > 2) {
        this.newQuestion.options.splice(index, 1)
      }
    },
    // 添加手动题目
    addManualQuestion() {
      // 验证题目内容
      if (!this.newQuestion.stem.trim()) {
        this.$message.warning('请输入题目内容')
        return
      }

      // 如果是选择题，验证选项
      if (this.newQuestion.type === 1) {
        const validOptions = this.newQuestion.options.filter(opt => opt.trim() !== '')
        if (validOptions.length < 2) {
          this.$message.warning('选择题至少需要2个选项')
          return
        }
        this.newQuestion.options = validOptions
      }

      // 创建新题目对象
      const newQuestionData = {
        question_id: this.pdfResults.length + 1,
        stem: this.newQuestion.stem.trim(),
        options: this.newQuestion.type === 1 ? this.newQuestion.options : null,
        isValid: true,
        selected: true // 默认选中
      }

      // 添加到结果列表
      this.pdfResults.push(newQuestionData)

      this.$message.success('题目添加成功！')
      this.showManualAddForm = false
      this.resetNewQuestion()
    },
    // 处理表格选择变化
    handleSelectionChange(selection) {
      this.selectedQuestions = selection
    },
    // 批量删除试题
    batchDeleteQuestions() {
      if (this.selectedQuestions.length === 0) {
        this.$message.warning('请先选择要删除的试题')
        return
      }

      const questionIds = this.selectedQuestions.map(item => item.id)
      const count = this.selectedQuestions.length

      this.$confirm(`此操作将永久删除选中的${count}道试题，是否继续？`, '批量删除确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.loading = true
          // 调用批量删除API
          this.performBatchDelete(questionIds)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 执行批量删除
    async performBatchDelete(questionIds) {
      try {
        // 调用批量删除API
        const result = await quBatchDel(questionIds)

        if (result.code === 1) {
          this.$message({
            type: 'success',
            message: `成功删除${questionIds.length}道试题！`
          })
        } else {
          this.$message({
            type: 'error',
            message: result.message || '批量删除失败'
          })
        }

        // 刷新页面数据
        this.getQuPage(
          this.pageNum,
          this.pageSize,
          this.searchName,
          this.selectedRepoSingleSearch,
          this.selValue
        )

        // 清空选择
        this.selectedQuestions = []
      } catch (error) {
        console.error('批量删除失败:', error)
        this.$message({
          type: 'error',
          message: '批量删除失败：' + (error.message || '未知错误')
        })
      } finally {
        this.loading = false
      }
    },

    // 清除题库筛选
    clearRepoFilter() {
      this.selectedRepoSingleSearch = ''
      this.$router.push({ path: '/questions-management' })
      this.getQuPage()
    },

        // 处理PDF导入按钮点击
    handlePdfImportClick() {
      // 获取当前选择的题库ID
      const currentRepoId = this.selectedRepoSingleSearch || this.$route.query.repoId

      // 添加调试信息
      console.log('当前选择的题库ID:', currentRepoId, '类型:', typeof currentRepoId)
      console.log('路由参数repoId:', this.$route.query.repoId)
      console.log('selectedRepoSingleSearch:', this.selectedRepoSingleSearch)

      // 检查是否为AMC题库（repoId为11）
      // 支持数字11和字符串"11"的比较
      if (currentRepoId && (currentRepoId === 11 || currentRepoId === '11' || currentRepoId === 14 || currentRepoId === 15 || currentRepoId === 16)) {
        // 是AMC题库，允许PDF导入
        this.pdfImportDialogVisible = true
      } else {
        // 不是AMC题库，显示提示信息
        this.$message.warning('PDF导入功能暂仅支持AMC题库，请先选择AMC题库后再使用此功能')
      }
    },

    // 显示清除知识点对话框
    showClearKnowledgeDialog() {
      this.selectedRepoForClearKnowledge = this.$route.query.repoId || this.selectedRepoSingleSearch || ''
      this.clearKnowledgeDialogVisible = true
    },

    // 确认清除知识点
    async confirmClearKnowledge() {
      try {
        const repoId = this.selectedRepoForClearKnowledge || this.$route.query.repoId || this.selectedRepoSingleSearch
        const repoTitle = repoId ? `题库ID(${repoId})` : '全部题库'

        const confirmed = await this.$confirm(
          `确定要清除"${repoTitle}"的所有知识点吗？此操作不可恢复！`,
          '警告',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(() => false)

        if (!confirmed) return

        const loading = this.$loading({
          lock: true,
          text: '正在清除知识点...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        const response = await clearAllGeneralKnowledge(repoId, null)
        loading.close()

        if (response && response.code === 1) {
          const deleted = response.data?.deleted || 0
          this.$message.success(`成功清除 ${deleted} 个知识点`)
          this.clearKnowledgeDialogVisible = false
        } else {
          this.$message.error(response?.msg || '清除失败')
        }
      } catch (error) {
        console.error('清除知识点失败:', error)
        this.$message.error('清除知识点失败：' + (error.message || '未知错误'))
      }
    },

    // 显示导入知识点对话框
    showImportKnowledgeDialog() {
      this.knowledgeTextarea = ''
      this.importKnowledgeDialogVisible = true
    },

    // 确认导入知识点
    async confirmImportKnowledge() {
      try {
        if (!this.knowledgeTextarea || !this.knowledgeTextarea.trim()) {
          this.$message.warning('请输入知识点内容')
          return
        }

        const repoId = this.$route.query.repoId || this.selectedRepoSingleSearch
        const repoTitle = this.$route.query.repoTitle || ''

        // 解析知识点列表（每行一个）
        const knowledges = this.knowledgeTextarea
          .split('\n')
          .map(line => line.trim())
          .filter(line => line.length > 0)

        if (knowledges.length === 0) {
          this.$message.warning('没有有效的知识点数据')
          return
        }

        const loading = this.$loading({
          lock: true,
          text: `正在导入 ${knowledges.length} 个知识点...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        const response = await importKnowledgeFromQuestions(knowledges, repoId, null)
        loading.close()

        if (response && response.code === 1) {
          const data = response.data || {}
          const processed = data.processed || 0
          const created = data.created || 0
          const errors = data.errors || []

          if (errors.length > 0) {
            this.$message.warning(`导入完成：处理 ${processed} 个，新建 ${created} 个，${errors.length} 个失败`)
            console.error('导入错误:', errors)
          } else {
            this.$message.success(`导入成功：处理 ${processed} 个知识点，新建 ${created} 个`)
          }

          this.importKnowledgeDialogVisible = false
          this.knowledgeTextarea = ''
        } else {
          this.$message.error(response?.msg || '导入失败')
        }
      } catch (error) {
        console.error('导入知识点失败:', error)
        this.$message.error('导入知识点失败：' + (error.message || '未知错误'))
      }
    },

    // 显示更新知识点对话框
    showUpdateKnowledgeDialog() {
      this.updateKnowledgeTextarea = ''
      this.updateKnowledgeFileList = []
      this.updateKnowledgeMode = 'file'
      // 初始化题库选择器，优先使用当前路由的题库
      this.selectedRepoForUpdateKnowledge = this.$route.query.repoId || this.selectedRepoSingleSearch || ''
      this.updateKnowledgeDialogVisible = true
    },

    // 处理更新知识点文件变化
    handleUpdateKnowledgeFileChange(file, fileList) {
      this.updateKnowledgeFileList = fileList.slice(-1)
    },

    // 处理更新知识点文件移除
    handleUpdateKnowledgeFileRemove(file, fileList) {
      this.updateKnowledgeFileList = fileList
    },

    // 确认更新知识点（根据题号）
    async confirmUpdateKnowledge() {
      try {
        const repoId = this.selectedRepoForUpdateKnowledge || this.$route.query.repoId || this.selectedRepoSingleSearch
        if (!repoId) {
          this.$message.warning('请先选择题库')
          return
        }

        let mappings = []
        const hierarchies = new Set()

        // 根据模式处理数据
        if (this.updateKnowledgeMode === 'file') {
          // 文件上传模式
          if (!this.updateKnowledgeFileList || this.updateKnowledgeFileList.length === 0) {
            this.$message.warning('请先选择Markdown文件')
            return
          }

          const loading = this.$loading({
            lock: true,
            text: '正在解析Markdown文件...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          try {
            // 调用外部API解析文件
            const formData = new FormData()
            formData.append('file', this.updateKnowledgeFileList[0].raw)

            const response = await fetch('http://123.56.176.195:7777/parse_md_unified/', {
              method: 'POST',
              body: formData
            })

            if (!response.ok) {
              throw new Error(`API请求失败: ${response.status}`)
            }

            const result = await response.json()
            loading.close()

            if (result.status !== 'success' || !result.problems || result.problems.length === 0) {
              this.$message.error('文件解析失败或没有找到题目')
              return
            }

            // 从API返回结果中提取题号和知识点
            for (const problem of result.problems) {
              const questionId = problem.question_id
              const tags = problem.question_tags

              if (questionId && tags) {
                mappings.push({ number: questionId, knowledge: tags })
                // 按分号拆分多个独立路径，每条路径单独加入hierarchies
                const paths = tags.split(/[；;]/).map(s => s.trim()).filter(Boolean)
                paths.forEach(p => hierarchies.add(p))
              }
            }

            if (mappings.length === 0) {
              this.$message.warning('没有找到有效的题号和知识点数据')
              return
            }

            this.$message.success(`成功解析 ${mappings.length} 个题目`)
          } catch (error) {
            loading.close()
            console.error('文件解析失败:', error)
            this.$message.error('文件解析失败：' + (error.message || '未知错误'))
            return
          }
        } else {
          // 手动输入模式
          if (!this.updateKnowledgeTextarea || !this.updateKnowledgeTextarea.trim()) {
            this.$message.warning('请输入题号和知识点映射')
            return
          }

          const lines = this.updateKnowledgeTextarea
            .split('\n')
            .map(line => line.trim())
            .filter(line => line.length > 0)

          if (lines.length === 0) {
            this.$message.warning('没有有效的数据')
            return
          }

          for (const line of lines) {
            const parts = line.split('|')
            if (parts.length !== 2) {
              this.$message.warning(`格式错误：${line}（应为：题号|知识点）`)
              return
            }

            const number = parts[0].trim()
            const knowledge = parts[1].trim()

            if (!number || !knowledge) {
              this.$message.warning(`数据不完整：${line}`)
              return
            }

            mappings.push({ number, knowledge })
            // 按分号拆分多个独立路径，每条路径单独加入hierarchies
            const kPaths = knowledge.split(/[；;]/).map(s => s.trim()).filter(Boolean)
            kPaths.forEach(p => hierarchies.add(p))
          }
        }

        // 开始更新知识点
        const loading = this.$loading({
          lock: true,
          text: `正在处理 ${mappings.length} 个题目的知识点...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        try {
          // 步骤1：使用hierarchies模式批量创建知识点
          // 后端会将 "代数-分数计算" 拆分为独立记录：代数(父级) + 分数计算(子级)
          const uniqueKnowledges = Array.from(hierarchies)

          const batchResp = await batchEnsureGeneralKnowledge(null, undefined, repoId, null, uniqueKnowledges)
          const batchData = (batchResp && batchResp.data) || batchResp || {}

          console.log('batchEnsure返回数据:', batchData)

          // 构建路径到ID的映射
          // hierarchies模式下:
          //   parents: key=第一级内容（如"代数"），value含id
          //   children: key=完整路径（如"代数-分数计算"），value含id
          const pathToId = new Map()

          if (batchData.parents) {
            Object.entries(batchData.parents).forEach(([content, info]) => {
              if (info && info.id) {
                pathToId.set(content, info.id)
                console.log(`一级知识点: "${content}" -> ID: ${info.id}`)
              }
            })
          }

          if (batchData.children) {
            Object.entries(batchData.children).forEach(([path, info]) => {
              if (info && info.id) {
                pathToId.set(path, info.id)
                console.log(`多级知识点: "${path}" -> ID: ${info.id}`)
              }
            })
          }

          console.log('路径->ID映射表:', pathToId)

          // 步骤2：构建批量更新数据
          // 一个题目可能属于多条路径（分号分隔），收集所有路径所有层级的ID
          // 例: "应用题-图表类-比例计算；统计概率-概率基础-图表分析"
          //   -> IDs: [应用题ID, 图表类ID, 比例计算ID, 统计概率ID, 概率基础ID, 图表分析ID]
          const updateMappings = []
          const errors = []

          for (const { number, knowledge } of mappings) {
            // 先按分号拆分成多条独立路径
            const allPaths = knowledge.split(/[；;]/).map(s => s.trim()).filter(Boolean)
            const ids = []
            const seenIds = new Set()

            for (const onePath of allPaths) {
              // 对每条路径按-逐级构建并收集ID
              const levels = onePath.split('-').map(s => s.trim()).filter(Boolean)
              let pathSoFar = ''
              for (const level of levels) {
                pathSoFar = pathSoFar ? `${pathSoFar}-${level}` : level
                const id = pathToId.get(pathSoFar)
                if (id && !seenIds.has(id)) {
                  ids.push(id)
                  seenIds.add(id)
                } else if (!id) {
                  console.warn(`找不到路径 "${pathSoFar}" 的ID`)
                }
              }
            }

            if (ids.length === 0) {
              errors.push(`题号 ${number}: 找不到知识点 "${knowledge}" 的任何层级ID`)
              console.error(`无法找到 "${knowledge}" 的ID，可用路径:`, Array.from(pathToId.keys()))
              continue
            }

            const knowledgeValue = ids.join(',')
            console.log(`✓ 题号 ${number}: "${knowledge}" -> IDs: ${knowledgeValue}`)
            updateMappings.push({
              number: number,
              knowledgeId: ids[ids.length - 1],
              knowledgeIds: knowledgeValue
            })
          }

          if (updateMappings.length === 0) {
            loading.close()
            this.$message.error('没有有效的更新数据')
            if (errors.length > 0) {
              this.$alert(errors.join('\n'), '错误详情', {
                confirmButtonText: '确定',
                type: 'error'
              })
            }
            return
          }

          // 步骤3：调用后端批量更新接口
          const updateResp = await batchUpdateKnowledgeByNumber(updateMappings, repoId)

          loading.close()

          if (updateResp && updateResp.code === 1) {
            this.$message.success(updateResp.msg || '更新成功')
            this.updateKnowledgeDialogVisible = false
            this.updateKnowledgeTextarea = ''
            this.updateKnowledgeFileList = []
            // 刷新列表
            this.getQuPage()
          } else {
            this.$message.error(updateResp?.msg || '更新失败')
          }
        } catch (error) {
          loading.close()
          throw error
        }
      } catch (error) {
        console.error('更新知识点失败:', error)
        this.$message.error('更新知识点失败：' + (error.message || '未知错误'))
      }
    }
  },
  mounted() {
    // 添加键盘事件监听
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    // 移除键盘事件监听
    document.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style>
.el-table .el-input {
  margin-bottom: 5px;
}

.el-table .el-button--text {
  padding: 2px 5px;
}

.dialog-footer {
  padding: 20px;
  text-align: right;
  border-top: 1px solid #e4e7ed;
}

.dialog-footer .el-button {
  margin-left: 10px;
}

/* 选项样式 */
.options-container {
  max-height: 200px;
  overflow-y: auto;
}

.option-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.option-label {
  display: inline-block;
  width: 20px;
  font-weight: bold;
  color: #409eff;
  margin-right: 8px;
}

.option-input {
  flex: 1;
  margin-right: 8px;
}

.option-delete-btn {
  flex-shrink: 0;
}

.preview-dialog {
  max-width: 600px;
}

.preview-dialog .el-message-box__content {
  max-height: 400px;
  overflow-y: auto;
  white-space: pre-line;
  font-family: 'Courier New', monospace;
  line-height: 1.5;
}

/* 图片预览区域样式 */
.upload-demo {
  margin-bottom: 15px;
}

.upload-demo .el-upload-dragger {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  transition: border-color 0.3s;
}

.upload-demo .el-upload-dragger:hover {
  border-color: #409eff;
}

/* 图片预览网格样式 */
.image-preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
}

.image-preview-item {
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 5px;
  transition: all 0.3s;
}

.image-preview-item:hover {
  border-color: #409eff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.image-preview-item img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 2px;
  display: block;
}

.image-preview-item .image-name {
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 5px;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-preview-item .remove-btn {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #f56c6c;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  padding: 0;
  font-size: 12px;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
}

.image-preview-item .remove-btn:hover {
  background: #f78989;
  transform: scale(1.1);
}

/* 表格横向滚动样式 */
.table-container {
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 表格固定列样式优化 */
.el-table .el-table__fixed-left {
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);
}

.el-table .el-table__fixed-right {
  box-shadow: -2px 0 6px rgba(0, 0, 0, 0.1);
}

/* 图片单元格样式 */
.image-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.thumbnail-image {
  width: 60px;
  height: 40px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #e4e7ed;
  object-fit: cover;
  transition: all 0.3s ease;
}

.thumbnail-image:hover {
  border-color: #409eff;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.image-name {
  font-size: 12px;
  color: #666;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-error-placeholder {
  width: 60px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  color: #c0c4cc;
}

/* 图片预览对话框样式 */
.image-preview-dialog .el-message-box {
  width: auto;
  max-width: 90vw;
}

.image-preview-dialog .el-message-box__content {
  padding: 20px;
}
</style>
